// extracted by mini-css-extract-plugin
export default {"mainContainer":"mainSection_mainContainer__3Rs4R","filtersContainer":"mainSection_filtersContainer__70b4T"};